/** Identity/expiry may change on requote; changed payment terms require explicit approval. */
export function sameFundingQuoteTerms(accepted, next) {
    return terms(accepted) === terms(next);
}
/** Initial review has no prior agreement; expiry/signature alone do not change terms. */
export function changedFundingQuoteTerms(previous, next) {
    return previous !== null && !sameFundingQuoteTerms(previous, next);
}
function terms(quote) {
    return JSON.stringify({
        source: [quote.source.asset.code, decimal(quote.source.amount)],
        destination: [
            quote.destination.asset.code,
            quote.destination.asset.caip19,
            decimal(quote.destination.amount),
        ],
        fees: Object.entries(quote.fees)
            .filter(([, fee]) => fee !== undefined)
            .sort(([left], [right]) => left.localeCompare(right))
            .map(([name, fee]) => [name, fee?.asset.code, fee ? decimal(fee.amount) : null]),
        wallet: quote.wallet,
        paymentMethod: quote.paymentMethod,
        feeBehavior: quote.feeBehavior,
        exchangeRate: decimal(quote.exchangeRate),
        exchangeRateType: quote.exchangeRateType,
        slippageBps: quote.slippageBps,
        limits: quote.limits,
        disclosures: quote.paymentDisclosures,
    });
}
function decimal(value) {
    if (!/^\d+(?:\.\d+)?$/.test(value))
        return value;
    const [whole = '0', fraction = ''] = value.split('.');
    const trimmed = fraction.replace(/0+$/, '');
    return `${whole.replace(/^0+(?=\d)/, '')}${trimmed ? `.${trimmed}` : ''}`;
}
